<template>
    <link-lov-select shape="none"
                     :type="type"
                     :color="color"
                     :size="size"
                     :lov-type="lov"
                     :parentLovType="option.parentLov"
                     :parentLovValue="option.parentLovVal"
                     @input="handleInput"
                     :value="filterValue.lov"/>
</template>

<script>
    import LinkLovSelect from "../../lov/link-lov-select";

    export default {
        name: "link-auto-table-filter-lov",
        components: {LinkLovSelect},
        props: {
            size: {type: String,},
            color: {type: String,},
            type: {type: String,},
            placeholder: {type: String, default: '搜索关键字...'},

            field: {},
            lov: {},
            filterValue: {},
            option: {},
        },
        methods: {
            handleInput(val) {
                this.filterValue.lov = val
                this.$emit('confirm', {type: 'lov', filtersRaw: this.getValue()});
            },
            getValue() {
                if (!this.filterValue.lov) return null
                return {
                    id: this.field,
                    property: this.field,
                    operator: '=',
                    value: this.filterValue.lov,
                }
            },
        },
    }
</script>
